import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const add_news = createAsyncThunk(
  "news/add_news",
  async (news, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/news-add", news, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_news = createAsyncThunk(
  "news/updatenews",
  async (news, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/news-update", news, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const news_image_update = createAsyncThunk(
  "news/news_image_update",
  async ({ oldImage, newImage, newsId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("oldImage", oldImage);
      formData.append("newImage", newImage);
      formData.append("newsId", newsId);
      const { data } = await api.post("/news-image-update", formData, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_newss = createAsyncThunk(
  "news/get_newss",
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/newss-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        {withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_news = createAsyncThunk(
  "news/get_news",
  async (newsId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/news-get/${newsId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_news = createAsyncThunk(
  "news/delete_news",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/news-delete/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

const newsSlice = createSlice({
  name: "news",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    newss: [],
    news: null,
    totalnews: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_news.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(add_news.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(add_news.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
      })

      .addCase(get_newss.fulfilled, (state, { payload }) => {
        state.totalnews = payload.totalnews || 0;
        state.newss = payload.newss || [];
      })

      .addCase(get_news.fulfilled, (state, { payload }) => {
        state.news = payload.news || null;
      })

      .addCase(update_news.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(update_news.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(update_news.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.news = payload.news || null;
        state.successMessage = payload.message;
      })

      .addCase(news_image_update.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(news_image_update.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(news_image_update.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.news = payload.news || null;
        state.successMessage = payload.message;
      })

      .addCase(delete_news.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(delete_news.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(delete_news.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.newss = state.newss.filter((p) => p._id !== payload.newsId);
      });
  },
});

export const { messageClear } = newsSlice.actions;
export default newsSlice.reducer;
